import { render, staticRenderFns } from "./UmsLocations.vue?vue&type=template&id=1365c880&"
import script from "./UmsLocations.vue?vue&type=script&lang=js&"
export * from "./UmsLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports